import React from 'react';
import autobind from 'autobind-decorator';

import {BaseTableColumn} from "../../Common/Tables/BaseTableColumn";
import {StreamBankLink} from "../../Common/StreamBankLink";

export class ContextTableColumn extends BaseTableColumn {
    constructor() {
        super();
    }

    @autobind
    _render() {
        const link = this.props.rowData?.link || null;

        if (!link) {
            return "N/A";
        }

        return <StreamBankLink
            className="sb-actionable-link"
            Href={link + "/permit"}
        >
            {this.props.Value}
        </StreamBankLink>;
    }
}
